import { Component, EventEmitter, Input, OnInit, Output, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';
import { SelectModel } from '../../../../core/models/select.model';
import { take, takeUntil, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { SelectMultipleValueInterface } from '../../../../core/interfaces/select-multiple.interface';
import { PaisRiesgoService } from '../../../../core/providers/services/pais-riesgo/pais-riesgo.service';
import { Numbers } from 'src/app/utils/constants';
import { RiskCountryRes } from 'src/app/core/interfaces/risk-country-res.interface';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss']
})
export class SelectComponent implements OnInit, OnChanges, OnDestroy {

  @Input() FORM_DATA: FormGroup;
  @Input() DATA_CONFIG: SelectModel;
  @Input() FORM_EXACT: boolean;
  @Input() EZ_SELECT: SelectMultipleValueInterface[] = [];

  /**
   * @description Si viene con un path asociado a una propiedad del formulario rellenara
   * la lista de opciones con el valor de esa propiedad
   */
  @Input() LIST_IN_FORM_PATH: string[];
  @Input() DISABLED: boolean;
  @Input() DATA_CHANGE: any;
  @Output() EMIT_CHANGES: EventEmitter<any> = new EventEmitter();
  finish = new Subject();
  listOptions: SelectMultipleValueInterface[] = [];
  fieldName: any;
  fieldErrors: any;
  fieldHasErrorB = false;
  fieldTouch = false;
  fieldRequired = false;
  fieldRiskError = false;
  fieldCountryRiskError = false;
  fieldCountryRiskAlert = false;
  ngModelSelected: any = { name: '' };
  /**
   * @params countryRisk
   */
  constructor(
    private countryRisk: PaisRiesgoService
  ) {
    this.countryRisk = countryRisk;
  }
 /**
  * @description Metodo que se ejecuta al inicio
  */
  ngOnInit() {
    if (!this.checkDataCompOk()) { return; }
    if (this.LIST_IN_FORM_PATH) {
      this.listOptions = this.FORM_DATA.get(this.LIST_IN_FORM_PATH).value;
      this.FORM_DATA.get(this.LIST_IN_FORM_PATH).valueChanges
        .pipe(
          takeUntil(this.finish),
          tap(obj => {
            this.listOptions = obj;
          })
        ).subscribe();
    } else {
      this.chargeDropdown();
    }

    this.fieldName = this.DATA_CONFIG.linkFormPath;
    this.fieldRequired = false;
    if (this.DISABLED === undefined) {
      this.DISABLED = false;
    }
    this.getError(this.fieldName);
    this.setDefaultValueForm();
    this.initObs();
  }
 /**
  * @description Metodo que se ejecuta al cambiar
  */
  ngOnChanges(changes: SimpleChanges): void {
    const INSURE_SELECTED: any = this.DATA_CONFIG.linkFormPath[0];
    if (!this.checkNumberOfInsuredInRange() && changes.DATA_CHANGE !== undefined &&
      changes.DATA_CHANGE.currentValue !== undefined) {
      const AUX_CHANGE: any = changes.DATA_CHANGE.currentValue;
      this.checkAuxChange(AUX_CHANGE);
    } else if (INSURE_SELECTED === 'incomingStudentsTravelAsistance' &&
      changes.DATA_CHANGE !== undefined && changes.DATA_CHANGE.currentValue !== undefined) {
      const AUX_CHANGE: any = changes.DATA_CHANGE.currentValue;
      this.checkAuxChange(AUX_CHANGE);
    } else if ((INSURE_SELECTED === 'particularTravelAsistance' || INSURE_SELECTED === 'sportTravelAsistance') &&
    this.DATA_CHANGE && this.DATA_CHANGE.value) {
      const AUX_CHANGE: any = changes.DATA_CHANGE.currentValue;
      this.checkAuxChange(AUX_CHANGE);
    } else {
      if (this.DATA_CHANGE && this.DATA_CHANGE.value && (this.DATA_CHANGE.value === 'España' ||
      this.DATA_CHANGE.value.name === 'España')) {
        this.ngModelSelected = this.DATA_CONFIG.options.list.find(e => e.name === 'España');
      }
    }
  }
/**
 * @param AUX_CHANGE aux change
 */
  checkAuxChange(AUX_CHANGE: any): void {
    if (AUX_CHANGE.name !== undefined) {
      this.auxChangeName(AUX_CHANGE);
    }
  }
 /**
  * @description Comprobar número de asegurados en rango
  */
  checkNumberOfInsuredInRange(): SelectMultipleValueInterface {
    return this.DATA_CONFIG.options.list.find(e => e.name === this.ngModelSelected.name);
  }
/**
 * @description cambiar nombre
 * @params auxChange
 */
  auxChangeName(auxChange: any): void {
    let canBeInsured: any;
    switch (auxChange.name) {
      case 'sector':
      case 'sport-70':
      case 'num-insured':
      case 'typeDoc':
      case 'typeDocSend':
        this.setValidityData(auxChange);
        break;
      case 'countryRisk':
        this.validateCountryRisk(auxChange.value);
        break;
      case 'municipio':
        canBeInsured = { name: auxChange.value.Des_Municipio, id: auxChange.value.Id_Municipio };
        this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setValue(canBeInsured);
        this.listOptions = [canBeInsured];
        this.ngModelSelected = { name: canBeInsured.name };
        this.EMIT_CHANGES.emit({ name: canBeInsured.name });
        break;
      case 'municipio-list':
        const CAN_BE_INSURED_AUX: any = [];
        auxChange.value.map(el => {
          CAN_BE_INSURED_AUX.push({
            name: el.Des_Municipio,
            id: el.Id_Municipio,
            Des_Municipio: el.Des_Municipio,
            Id_Municipio: el.Id_Municipio,
            Des_Provincia: el.Des_Provincia,
            Id_Provincia: el.Id_Provincia
          });
        });
        this.listOptions = CAN_BE_INSURED_AUX;
        break;
      case 'country':
        canBeInsured = { name: auxChange.value.name, id: auxChange.value.id };
        this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setValue(canBeInsured);
        this.ngModelSelected = { name: canBeInsured.name };
        this.EMIT_CHANGES.emit({ name: canBeInsured.name });
        break;
      case 'setSpain':
        canBeInsured = { name: auxChange.value.name, id: auxChange.value.id };
        this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setValue(canBeInsured);
        this.ngModelSelected = { name: canBeInsured.name };
        this.EMIT_CHANGES.emit({ name: canBeInsured.name });
        break;
      case 'destiny':
        this.setValidityData(auxChange);
        canBeInsured = { name: auxChange.value.name, id: auxChange.value.id };
        this.listOptions = [canBeInsured];
        this.DISABLED = true;
        break;
      case 'sport':
        this.setValiditySport(auxChange);
        break;
      case 'guarantee':
        this.listOptions = auxChange.value;
        break;
      default:
        break;
    }
  }
/**
 * @description Método que se ejecuta al final
 */
  ngOnDestroy() {
    this.finish.next(true);
  }
  /**
   * @description inicializa objeto
   */
  initObs(): void {
    if (this.FORM_DATA && this.DATA_CONFIG && this.DATA_CONFIG.linkFormPath) {
      const AUX: AbstractControl = this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath);
      this.ngModelSelected = { name: AUX.value };
      if (AUX.value && AUX.value.name) {
        this.ngModelSelected = { name: AUX.value.name };
      }
    }
  }
/**
 * @description carga el dropDown
 */
  chargeDropdown(): void {
    this.listOptions = this.DATA_CONFIG.options.list;
  }
  /**
   * @description valida el pais
   * @params val
   */
  validateCountryRisk(val: any): void {
    this.fieldCountryRiskAlert = false;
    if (val.name !== undefined) {
      this.countryRisk.getCountryRisk([val.name])
        .pipe(take(1))
        .subscribe((res: RiskCountryRes[]) => {
          const pais: RiskCountryRes = res[0];
          if (this.fieldCountryRiskError === true && (val.id === Numbers.number19001 || val.id === Numbers.number19002 ||
             val.id === Numbers.number19004 || val.id === Numbers.number19007)) {
            this.fieldCountryRiskError = true;
            if (pais.indAlertaRiesgo === 1) {
              this.fieldCountryRiskAlert = true;
            }
          } else {
            this.fieldCountryRiskError = false;
          }
          if (pais.riesgo === 1) {
            this.fieldCountryRiskError = true;
            if (pais.indAlertaRiesgo === 1) {
              this.fieldCountryRiskAlert = true;
            }
          }
          const LINK_FIELD: string[] = this.DATA_CONFIG.linkFormPath;
          let errorsA: any = null;
          let errorE = false;
          if (this.fieldCountryRiskError) {
            this.FORM_DATA.get(LINK_FIELD).setErrors({ required: true });
          } else {
            const ERRORS: ValidationErrors = this.FORM_DATA.get(LINK_FIELD).errors;
            if (ERRORS !== null) {
              delete ERRORS.required;
              errorE = Object.keys(ERRORS).length === 0;
            }
            if (errorE === true) { errorsA = null;
            } else { errorsA = ERRORS; }

            this.FORM_DATA.get(LINK_FIELD).setErrors(errorsA);
          }
        });
    }
  }
 /**
  * @description guarda los datos
  * @params auxChange
  */
  setValidityData(auxChange: any): void {
    const CAN_BE_INSURED: any = { name: auxChange.value.name, id: auxChange.value.id };
    this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setValue(CAN_BE_INSURED);
    this.ngModelSelected = { name: CAN_BE_INSURED.name };
    this.EMIT_CHANGES.emit({ name: CAN_BE_INSURED.name });
  }
/**
 * @description guarda el error
 * @params auxChange
 */
  setErrorTypeDoc(auxChange: any): void {
    const LINK_FIELD: string[] = this.DATA_CONFIG.linkFormPath;
    let errorsA: any = null;
    let errorE = false;
    if (auxChange.value === 'error') {
      this.FORM_DATA.get(LINK_FIELD).setErrors({ required: true });
    } else {
      const ERRORS: ValidationErrors = this.FORM_DATA.get(LINK_FIELD).errors;
      if (ERRORS !== null) {
        delete ERRORS.required;
        errorE = Object.keys(ERRORS).length === 0;
      }
      if (errorE === true) { errorsA = null;
      } else { errorsA = ERRORS; }

      this.FORM_DATA.get(LINK_FIELD).setErrors(errorsA);
    }
  }
  /**
   * @description validacion
   * @params auxChange
   */
  setValiditySport(auxChange: any): void {
    let linkfield: any;
    let errorsA: any = null;
    let errorE = false;
    this.fieldRiskError = false;
    if (auxChange.value.id > Numbers.number10) { this.fieldRiskError = true; }
    linkfield = this.DATA_CONFIG.linkFormPath;
    if (this.fieldRiskError) {
      this.FORM_DATA.get(linkfield).setErrors({ required: true });
    } else {
      const ERRORS: ValidationErrors = this.FORM_DATA.get(linkfield).errors;
      if (ERRORS !== null) {
        delete ERRORS.required;
        errorE = Object.keys(ERRORS).length === 0;
      }
      if (errorE === true) { errorsA = null;
      } else { errorsA = ERRORS; }

      this.FORM_DATA.get(linkfield).setErrors(errorsA);
      this.ngModelSelected = { name: auxChange.value };
      if (auxChange.value.name) { this.ngModelSelected = { name: auxChange.value.name }; }
    }
  }

  /**
   * @description Es para comprobar que todos los inputs tienen datos para poder iniciar el componente
   */
  public checkDataCompOk(): boolean {
    return this.FORM_DATA && this.DATA_CONFIG && this.DATA_CONFIG.linkFormPath && this.DATA_CONFIG.linkFormPath.length > 0;
  }

  /**
   * @description Para guardar el valor por defecto del formulario desde la configuracion
   */
  private setDefaultValueForm(): void {
    if (this.DATA_CONFIG &&
      this.DATA_CONFIG.options &&
      this.DATA_CONFIG.options.default &&
      this.DATA_CONFIG.options.default.selected &&
      this.DATA_CONFIG.options.default.selected.length > 0 &&
      this.DATA_CONFIG.linkFormPath &&
      this.DATA_CONFIG.linkFormPath.length > 0
    ) {
      this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath)
        .setValue(this.DATA_CONFIG.options.default.selected);

    }

  }

  /**
   * @description Actualiza los cambios del input desde el html
   */
  public updateData(ev: { value: { name: string } }): void {
    if (!this.checkDataCompOk()) { return; }
    this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setValue(ev.value);
    if (ev.value.name !== '') { this.fieldHasErrorB = false;
    } else { this.fieldHasErrorB = true; }
    this.EMIT_CHANGES.emit(ev.value);
  }

  /**
   *
   * @param field field to check if is valid
   */

  fieldHasError(): boolean {
    let hasError = false;
    if (this.FORM_DATA) {
      hasError = this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).invalid
        && (this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).dirty
          || this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).touched);
    }
    return hasError;
  }

  /**
   *
   * @param field field to mark focus
   */
  onFocusInput(controlName: any): void {
    this.FORM_DATA.get(controlName).markAsUntouched();
    this.fieldTouch = true;
    const VALUE_EL: any = this.FORM_DATA.get(controlName).value.name;
    if (this.fieldRequired && VALUE_EL !== '') {
      this.fieldHasErrorB = false;
    }
    if (this.fieldRequired && VALUE_EL === '') {
      this.fieldHasErrorB = true;
    }
  }

  /**
   *
   * @param field field to check erros
   */
  getError(controlName: string): string {
    let errorMsg = '';
    if (this.FORM_DATA) {
      this.fieldErrors = '';
      const CONTROL: AbstractControl = this.FORM_DATA.get(controlName);
      if (CONTROL.invalid && CONTROL.errors !== null) {
        errorMsg = JSON.stringify(CONTROL.errors);
        this.fieldErrors = CONTROL.errors;
        this.fieldRequired = this.fieldErrors.required;
      }
    }
    return errorMsg;
  }

}
